<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <button :class="buttonStyle" :disabled="disabled || loading">
        <slot></slot>
        <span v-if="icon || loading" class="icon">
            <IconLoader v-if="loading" />
            <IconArrowNext v-else-if="icon == 'next'" />
            <IconArrowPrev v-else-if="icon == 'prev'" />
            <IconSend v-else-if="icon == 'send'" />
        </span>
    </button>
</template>

<script setup lang="ts">
import IconArrowNext from "@/components/icons/IconArrowNext.vue";
import IconArrowPrev from "@/components/icons/IconArrowPrev.vue";
import IconLoader from "@/components/icons/IconLoader.vue";
import IconSend from "@/components/icons/IconSend.vue";

import { computed, defineProps } from "vue";

const props = defineProps<{
    size?: "medium" | "large";
    color?: "primary" | "secondary";
    icon?: "next" | "prev" | "send";
    outlined?: boolean;
    loading?: boolean;
    disabled?: boolean;
}>();

const buttonStyle = computed(() => {
    const styles: string[] = [props.color || "primary", props.size || "medium"];
    if (props.outlined) {
        styles.push("outlined");
    }
    return styles.join(" ");
});
</script>

<style lang="sass">
.loader
</style>